import React, { createRef, useEffect } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { observer } from 'mobx-react';

import RotateDevice from './components/rotate-device/RotateDevice';

import AuthPage from './pages/auth/AuthPage';
import ProfilePage from './pages/profile/ProfilePage';
import HomePage from './pages/home/HomePage';
import NotFoundPage from './pages/not-found/NotFoundPage';

import useResize from './hooks/useResize';

import { device } from './utils/device';
import { useLocalStore, useStore } from './stores';

import styles from './App.module.scss';
import Spinner from './components/spinner/Spinner';

type LocalStore = {
    isProcess: boolean,
};

export default observer(function App() {
    const viewportRef = createRef<HTMLDivElement>();

    const { authStore, userStore } = useStore();
    const { localStore } = useLocalStore<LocalStore>({
        isProcess: false,
    });

    useEffect(() => {
        if (authStore.isAuthenticated) {
            localStore.isProcess = true;

            userStore.findById(authStore.id)
                .then(user => (authStore.user = user))
                .catch(() => (authStore.user = null))
                .finally(() => (localStore.isProcess = false));
        } else {
            authStore.user = null;
        }
    }, [authStore.isAuthenticated]);

    useResize(() => {
        const w = window.innerWidth;
        const h = window.innerHeight;

        let tw = 375;
        let th = 560;
        if (!device.isShortScreen) {
            tw = 375;
            th = 640;
        }

        const scale = Math.min(w / tw, h / th);
        const height = 100 / scale;

        if (viewportRef.current) {
            viewportRef.current.style.height = `${+height.toFixed(4)}%`;
            viewportRef.current.style.transform = `scale(${+scale.toFixed(4)})`;
        }
    }, [viewportRef]);

    if (authStore.isAuthenticateProcess || localStore.isProcess) {
        return (
            <Spinner/>
        );
    }

    setTimeout(() => window.dispatchEvent(new Event('resize')), 100);

    return (
        <>
            <RotateDevice/>

            <div className={styles.viewport} ref={viewportRef}>
                <Switch>
                    <Route path="/auth"><AuthPage/></Route>
                    <Route exact path="/terms"><NotFoundPage/></Route>

                    {authStore.isAuthenticated && <Route exact path="/"><Redirect to={authStore.user?.role === '' ? '/profile/role' : '/search'}/></Route>}
                    {authStore.isAuthenticated && <Route path="/profile"><ProfilePage/></Route>}
                    {authStore.isAuthenticated && authStore.user?.role !== '' && <Route path="/:page/:id?"><HomePage/></Route>}
                    {authStore.isAuthenticated && <Route><Redirect to={authStore.user?.role === '' ? '/profile/role' : '/search'}/></Route>}

                    {!authStore.isAuthenticated && <Route exect path="/"><Redirect to="/auth"/></Route>}
                </Switch>
            </div>
        </>
    );
});
